import { Injectable, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PremisesLink, PremisesType, WorkplaceBillingAutomationConfig } from '../projects/premises-management/premises.types';
import { WebSocketMessage } from '../../../core/websocket/websocket.types';

@Injectable({
    providedIn: 'root'
})
export class TaskListService {

    private _automationConfigWsMessage = signal<WorkplaceBillingAutomationConfig>(undefined);
    automationConfigWsMessage = this._automationConfigWsMessage.asReadonly();

    constructor(
        private router: Router,
    ) {}

    handleAutomationConfigWebsocketMessage(message: WebSocketMessage) {
        this._automationConfigWsMessage.set(message.payload);
    }

    navigateToPremise(premise: PremisesLink, activatedRoute: ActivatedRoute): string {
        const path = this.resolvePremisePath(premise);

        if (path) {
            this.router.navigate([path], { 
                relativeTo: activatedRoute ,
                queryParams: { premisesCode: premise.premisesCode,  },
                queryParamsHandling: 'merge'
            });     
        }
        return path;
    }

    private resolvePremisePath(premise: PremisesLink): string | null {
        const urlSegments = this.router.url.split('/');
        const urlPremisesType = urlSegments[urlSegments.length - 1]?.split('?')[0];

        let path = '';

        if (urlSegments.length === 3 
            && ((premise.premisesType === PremisesType.CENTER && urlPremisesType !== 'center')
                || (premise.premisesType === PremisesType.LOGISTIC_CENTER && urlPremisesType !== 'generic')
                || (premise.premisesType === PremisesType.HOTEL && urlPremisesType !== 'housekeeping'))) {
            path = '../';
        } else if (urlSegments.length === 2) {
            path = './';
        }

        if (!path) return null;

        switch (premise.premisesType) {
            case PremisesType.HOTEL:
                return path + 'housekeeping';
            case PremisesType.CENTER:
                return path + premise.premisesType.toLowerCase();
            default:
                return path + 'generic';
        }
    }
}
